import React from 'react';
import {SessionContextProvider} from './session-context-provider';
import App from './App';

// Public mount surface, called by portal as:
//
//   <TenetEditor
//     user={{ id, email, display_name, avatar_url, role, workgroups }}
//     workgroup="foundation"
//     spec_path="common/openapi.yaml"
//     aiEnabled={true}
//     onSpecChange={...}
//     onCommentAnchorChange={...}
//     rightPanelSlots={[{key, label, component}, ...]}
//   />
//
// All props are optional today; portal will populate them as the
// integration contract (§3 of tenetai-editor-README.md / §9 of the
// portal README) lands phase-by-phase.
//
// When `user` is absent, the editor falls back to its existing
// standalone bootstrap (window.username from index.html's shim, fed
// by ?user=&role= query params or dev cookies or VITE_* env). This
// is the path tests + local dev rely on; nothing breaks if portal
// never mounts the component.
//
// `aiEnabled`, `onSpecChange`, `onCommentAnchorChange`, and
// `rightPanelSlots` are accepted in the prop shape today but
// fully wired phase-by-phase — see §10(e) (rightPanelSlots),
// Phase A (event callbacks), and §6 of the editor README for the
// AI roll-out.
export function TenetEditor(props) {
    const {user, rightPanelSlots, aiEnabled, onSpecChange, onCommentAnchorChange} = props;
    // SessionContextProvider currently bootstraps a synthetic session
    // from the URL query / cookies in standalone mode. When portal-
    // driven, it'll sit downstream of portal's session-cookie
    // middleware (§10c/d) and pick up the real session from there.
    //
    // editorProps groups the portal-controlled bits (right pane slots,
    // AI gate, change/anchor callbacks) so AppContext can expose them
    // without prop-drilling through every page-level component. Each
    // field is optional; when undefined the editor falls back to its
    // standalone behavior — for `aiEnabled` that means
    // ai/feature-flag.js's URL/window/env resolution; for slots it
    // means "right pane = AI chat only (or nothing if AI is off)".
    return (
        <SessionContextProvider>
            <App
                user={user}
                editorProps={{rightPanelSlots, aiEnabled, onSpecChange, onCommentAnchorChange}}
            />
        </SessionContextProvider>
    );
}

export default TenetEditor;
